<template>
    <div class="file-uploader">
        <div v-show="uploading" class="app-loader__wrapper">
            <app-loader />
        </div>
        <form v-show="!uploading"
            method="POST"
            :action="url"
            enctype="multipart/form-data">
            <slot></slot>
            <fieldset :disabled="disabled">
                <input type="file"
                    ref="file"
                    :name="name"
                    @change="onChange($event)"
                    :accept="extensions">
                <div class="d-flex">
                    <button type="button"
                        data-file-select
                        :class="['element-button', { 'btn-block': buttonBlock }, { 'element-button--icon': buttonIcon }, buttonClass || 'element-button--secondary']"
                        :disabled="uploading"
                        v-show="!uploading || !autoUpload"
                        @click="replace"
                        :title="label">
                        <i :class="`icon-${buttonIcon}`" v-if="buttonIcon"></i>
                        <span v-else>{{ label }}</span>
                    </button>
                    <button type="submit"
                        class="element-button element-button--secondary"
                        v-if="files.length"
                        :disabled="uploading"
                        @click.prevent="submit">
                        {{ uploading ? 'Uploading...' : 'Upload' }}
                    </button>
                </div>
            </fieldset>
            <div class="alert alert-danger mt-3" v-if="errors && showErrors">
                <small v-for="(error, prop) in errors" :key="`error-${prop}`">{{ error[0] }}</small>
            </div>
        </form>
    </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

export default {
    props: {
        url: {
            type: String
        },
        buttonLabel: {
            type: String,
            default: 'Upload File'
        },
        buttonClass: {
            type: String,
            default: ''
        },
        buttonBlock: {
            type: Boolean,
            default: false
        },
        buttonIcon: {
            type: String,
            default: null
        },
        autoUpload: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            default: 'asset'
        },
        ajax: {
            type: Boolean,
            default: true
        },
        showLoad: {
            type: Boolean,
            default: true
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        validExtensions: {
            type: Array,
            default: () => ['*']
        },
        options: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            files: [],
            uploading: false,
            errors: false
        }
    },
    computed: {
        label () {
            return this.files.length ? `${this.files[0].name}` : this.buttonLabel
        },
        extensions () {
            return this.validExtensions.join(',')
        }
    },
    methods: {
        onChange (event) {
            this.errors = false
            this.files = event.target.files
            if (this.files.length) {
                this.submit()
            }
        },
        replace () {
            this.$refs.file.click()
        },
        async submit () {
            this.uploading = true
            this.$emit('start')

            if (this.ajax) {
                // generate formdata
                const formData = new FormData()

                // attach all files
                _.each(this.files, (file) => {
                    formData.append(this.name, file)
                })

                // attach options
                _.each(this.options, (value, key) => {
                    formData.append(key, value)
                })

                try {
                    const response = await axios.post(this.url, formData, {
                        onUploadProgress: (event) => { this.$emit('progress', event) }
                    })
                    this.errors = false
                    this.$emit('success', _.get(response, 'data.data'))
                    this.files = []
                    this.$refs['file'].value = ''
                    this.uploading = false
                } catch (err) {
                    let errors = _.get(err, 'response.data.errors', false)
                    if (!errors && _.get(err, 'response.status') === 413) {
                        errors = { 'file-size': ['File size too large.'] }
                    }
                    this.uploading = false
                    this.files = []
                    console.log(errors)
                    this.$emit('fail', errors)
                    this.errors = errors
                }
            } else {
                this.$el.submit()
            }
        }
    }
}
</script>
